import { queryOptions, UseQueryOptions } from '@tanstack/react-query'
import { Language } from '../../../types/user/User'
import { Formula } from '../types/Formula'
import { getFormulaOptions } from './getFormulaOptions'

type UseFormulaOptionsProps<TData> = {
  companyId?: string
  lng?: Language
  select?: (data: Formula[], lng: Language) => TData
}

export const useFormulaOptions = <TData = Formula[]>({
  companyId,
  lng = Language.fi,
  select
}: UseFormulaOptionsProps<TData>) => {
  return queryOptions(getFormulaOptions(companyId, lng, select)) as UseQueryOptions<TData>
}
